export default __webpack_public_path__ + "static/media/ofr-ing.44a09d3b.png";